import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgUnsupportedBrowser',
})
export default class CmgUnsupportedBrowser extends Vue { 

  get pepperImg(): string {
    return this.$appStore.state.cms.images.icons.pepperBadge.default;
  }
}
